
import "bootstrap/dist/css/bootstrap.css";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

const tas = [
    {
        date: "2023 Spring (Q4)",
        html: "Data Visualization for Analysis and Communication, Harvard Business School",
    },
    {
        date: "2022 Spring",
        html: "MSBD5005 - Data Visualization, HKUST",
    },
    {
        date: "2020 Fall",
        html: "COMP1021 - Introduction to Computer Science, HKUST",
    },
    {
        date: "2019 Fall",
        html: "COMP3711 - Design and Analysis of Algorithms, HKUST",
    },
    {
        date: "2018 Fall",
        html: "MSBD5005 - Data Visualization, HKUST",
    },
    {
        date: "2017 Fall, 2018 Spring",
        html: "COMP 1022Q - Introduction to Computing with Excel VBA, HKUST",
    },
];

export default defineComponent({
    name: "App",
    components: {},
    setup() {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
        });

        return {
            ...toRefs(state),
            tas,
        };
    },
    computed: {},
});
